import React, { useState } from "react"
import { useInfiniteHits, useCurrentRefinements } from 'react-instantsearch';
import Hit from "./hit"

const defaultHide = () => true;
var scrollEventRegistered = false;

const handleScroll = (showMore, isLastPage, setIsHide) => {
        let documentHeight = document.body.scrollHeight;
        let currentScroll = window.scrollY + window.innerHeight;
        // When the user is [modifier]px from the bottom, fire the event.
        let modifier = 200; 
        if(currentScroll + modifier > documentHeight) {
            if( isLastPage == false )
            {
                setIsHide(false);
                showMore();
            }
        }
}
const handleScrollMobile = ( showMore, isLastPage, setIsHide ) => {
    let documentHeight = document.body.scrollHeight;
    let currentScroll = window.scrollY + window.innerHeight;
    // When the user is [modifier]px from the bottom, fire the event.
    let modifier = 500; 
    if(currentScroll + modifier > documentHeight) {
 
        if( isLastPage == false )
        {
            setIsHide(false);
            showMore();
        }
    }
}

const loadMore = (showMore, isLastPage, setIsHide) => {
    if( !isLastPage  )
    {
        if(scrollEventRegistered == false )
        {
            scrollEventRegistered = true;
            window.addEventListener('scrollend', function(){
                handleScroll( showMore, isLastPage, setIsHide );
            });
            window.addEventListener('touchend', function(){
                handleScrollMobile( showMore, isLastPage, setIsHide );
            });
        }
    }
}
const style = {
    width: '50px',
    margin:'10px auto'
  };
  const loadMoreImg = (isLastPage, setIsHide) => {
    if(!isLastPage)
    {
      let timer = setTimeout(() => setIsHide(true), 5000);
    }

}
function Results({ colour }){
  const [isHide, setIsHide] = useState( defaultHide() );
  const { hits, isLastPage, showMore } = useInfiniteHits();

    const { items } = useCurrentRefinements();
    const colourRefinement = items.find(
        (item) => item.attribute === 'ostendoTrimColour'
        );
   var colorSelected = [];
   if(colourRefinement?.refinements.length)
   {
        colourRefinement?.refinements.map(function(refinement, index){ colorSelected[index] = refinement.label   })
   }
   else
   {
    colorSelected = null;
   }
  
    return (
        <div>
            {loadMore(showMore, isLastPage, setIsHide)} 
            <div className="search__results" >
                {hits.map(hit => <Hit key={hit.objectID} hit={hit} colour={colorSelected} />)}
            </div>
            {!isLastPage && !isHide &&
            <img src={"/images/suffering.gif"} style={style} alt={"loading"} />}
            {loadMoreImg(isLastPage, setIsHide)}
        </div>
    )
}

export default Results